import { ApplicationEvent } from './application-event.model';
import { ApplicationEventType } from '../constants';
import { GATrackingEventType, GaTrackingEventLabel } from '~shared/modules/ga-tracking/constants';

export class ElementVisibilityInViewportApplicationEvent implements ApplicationEvent {

  type = ApplicationEventType.Scrolling;

  constructor(private page: GATrackingEventType, private element: GaTrackingEventLabel | string) {
  }

  getPayload(): any {
    return {
      page: this.page,
      element: this.element
    };
  }
}
